import styled from './Spinner.module.scss'

import LottieSpinner from '../LottieSpinner/LottieSpinner'
import { useEffect } from 'react'

const Spinner = () => {
  const disableScroll = (event: WheelEvent | KeyboardEvent | TouchEvent) => {
    event.preventDefault()
  }
  useEffect(() => {
    const options = {
      passive: false,
    } as AddEventListenerOptions
    window.addEventListener(
      'keydown',
      disableScroll as EventListenerOrEventListenerObject,
      options
    )
    window.addEventListener(
      'wheel',
      disableScroll as EventListenerOrEventListenerObject,
      options
    )
    window.addEventListener(
      'touchmove',
      disableScroll as EventListenerOrEventListenerObject,
      options
    )

    return () => {
      window.removeEventListener(
        'keydown',
        disableScroll as EventListenerOrEventListenerObject,
        options
      )
      window.removeEventListener(
        'wheel',
        disableScroll as EventListenerOrEventListenerObject,
        options
      )
      window.removeEventListener(
        'touchmove',
        disableScroll as EventListenerOrEventListenerObject,
        options
      )
    }
  }, [])

  return (
    <div className={styled.wrapper}>
      <div className={styled.content}>
        <h3 className={styled.title}>Consiguiendo tu oferta</h3>
        <div className={styled.spinner}>
          <LottieSpinner />
        </div>
        <span className={styled.description}>
          Danos un segundo. No cierres ni recargues la página, por favor
        </span>
      </div>
    </div>
  )
}

export default Spinner
